// src/components/LanguageSelector.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemText,
    ListItemIcon,
} from '@mui/material';
import { Globe } from 'lucide-react';

const LANGUAGES = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'uk', name: 'Українська', flag: '🇺🇦' },
    { code: 'zh', name: '中文', flag: '🇨🇳' }
];

const LanguageSelector = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { i18n } = useTranslation();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageSelect = async (languageCode) => {
        try {
            await i18n.changeLanguage(languageCode);
            handleClose();
        } catch (error) {
            console.error('Error changing language:', error);
        }
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 1 }}
                aria-label="Select language"
            >
                <Globe size={20} />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        minWidth: 200,
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5
                    },
                }}
            >
                {LANGUAGES.map((language) => (
                    <MenuItem
                        key={language.code}
                        selected={i18n.language === language.code}
                        onClick={() => handleLanguageSelect(language.code)}
                    >
                        <ListItemIcon sx={{ fontSize: 20 }}>
                            {language.flag}
                        </ListItemIcon>
                        <ListItemText primary={language.name} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default LanguageSelector;